import PlanMain from "@/components/pricing/plan-main";

import Head from "next/head";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";
import { getPricingPlans } from "@/services/pricing";
import { SubscriptionPlan } from "@/@types/SubscriptionPlan";

type Props = {
  planData: SubscriptionPlan;
  error: string;
  allPlans: SubscriptionPlan[];
};

export default function Plan({ planData, allPlans, error }: Props) {
  return (
    <>
      <Head>
        <title>
          {seoData.GUEST_SUBSCRIPTION_PLAN_PAGE.title +
            planData.title +
            " Plan"}
        </title>
        <SeoMetaData
          data={{
            ...seoData.GUEST_SUBSCRIPTION_PLAN_PAGE,
            canonicalUrl: `${
              seoData.GUEST_SUBSCRIPTION_PLAN_PAGE.canonicalUrl
            }/${planData.title?.replace(" ", "-").toLowerCase()}`,
          }}
        />
      </Head>
      {!error ? (
        <PlanMain planData={planData} allPlans={allPlans} />
      ) : (
        <div className="text-center">
          <h2>Unexpected error occurred where fetching subscription plans.</h2>
        </div>
      )}
    </>
  );
}

export async function getServerSideProps(context: any) {
  const { plan } = context.params;

  try {
    const { data } = await getPricingPlans();
    if (data.status) {
      const activePlan = data.data.find(
        (p: any) => p.title.toLowerCase() === plan.replace("-", " ")
      );

      return {
        props: {
          planData: activePlan,
          allPlans: data.data,
        },
      };
    } else {
      return {
        props: {
          error: data.message,
        },
      };
    }
  } catch (error) {
    return {
      props: {
        error:
          "Unexpected error occurred while fetching plans. Please try again later",
      },
    };
  }
}
